"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PatientEncounter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var info_cell_1 = require("../info-cell/info-cell");
var case_prop_accessor2_1 = require("../case-prop-accessor/case-prop-accessor2");
var encounter_data_transformers_1 = require("./encounter-data.transformers");
var chevron_1 = __importDefault(require("../svgs/chevron"));
var conditional_1 = require("../conditional/conditional");
var ui_common_1 = require("@codametrix/ui-common");
var svg_icons_1 = require("../svgs/svg-icons");
var getCoderNotesLookupParams = ui_common_1.AmplifyCore.coderNotesUtils.getCoderNotesLookupParams;
var DataStyles = {
    s: 'col-3 col-lg-4 col-md-4',
    ms: 'col-4 col-md-6',
    m: 'col-8',
    l: 'col-12'
};
function CellMaker(propAccessor, rawCaseRun, fieldEditorInfo, capability, showProviderInfo) {
    var dataTransformer = (0, encounter_data_transformers_1.DataTransformers)(propAccessor, rawCaseRun);
    return function (def) {
        var _a;
        var cellClassName = DataStyles[def.dataSize];
        var value = def.transformer
            ? dataTransformer[def.transformer](def.property)
            : propAccessor(def.property, 'N/A');
        var additionalInfo = (_a = def === null || def === void 0 ? void 0 : def.additionalInfo) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, info) {
            var key = info === null || info === void 0 ? void 0 : info.label;
            var value = info.transformer
                ? dataTransformer[info.transformer](info.property)
                : propAccessor(info.property, 'N/A');
            // Ensure both key and value are strings
            acc[key] = value === null || value === void 0 ? void 0 : value.toString();
            return acc;
        }, {}); // Initialize an empty object with string key-value types
        var _handleUpdate = function (updates) {
            var _a, _b;
            var caserun_uid = rawCaseRun.caserun_uid, service_line = rawCaseRun.service_line;
            var _c = fieldEditorInfo.caseEdits[def.key], initialVal = _c.initialVal, mappedValues = _c.mappedValues;
            if (updates.hasOwnProperty('patient_type')) {
                var patientTypeValue_1 = updates['patient_type'];
                var mappedValues_1 = ((_a = fieldEditorInfo.caseEdits['patient_class']) === null || _a === void 0 ? void 0 : _a.mappedValues) || [];
                var value_1 = (_b = mappedValues_1.find(function (item) { return item.label === patientTypeValue_1; })) === null || _b === void 0 ? void 0 : _b.value;
                if (value_1 !== undefined) {
                    rawCaseRun['patient_class'] = value_1;
                    updates['patient_class'] = value_1;
                }
            }
            fieldEditorInfo.updateCase({
                caseRunUid: caserun_uid,
                serviceLine: service_line == 'Inpatient Professional Coding'
                    ? 'ipc'
                    : service_line,
                caseUpdates: updates,
                initialVal: initialVal,
                mappedValues: mappedValues
            });
        };
        return ((0, jsx_runtime_1.jsx)(info_cell_1.InfoCell, { className: cellClassName, cellKey: def.key, label: def.label, value: value, fieldType: def.fieldType, fieldEditorInfo: __assign(__assign({}, fieldEditorInfo), { updateCase: function (updates) { return _handleUpdate(updates); } }), capability: capability, showProviderInfo: showProviderInfo, hasLink: (def === null || def === void 0 ? void 0 : def.additionalInfo) ? def === null || def === void 0 ? void 0 : def.hasLink : false, additionalInfo: additionalInfo }, "".concat(def.key)));
    };
}
var CellPatientMaker = function (propAccessor, rawCaseRun) {
    var dataTransformer = (0, encounter_data_transformers_1.DataTransformers)(propAccessor, rawCaseRun);
    return function (def) {
        var value = def.transformer
            ? dataTransformer[def.transformer](def.property)
            : propAccessor(def.property, 'N/A');
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-cell" }, { children: [value, def.addHr ? (0, jsx_runtime_1.jsx)("div", { className: "vertical-divider" }) : null] }), def.key));
    };
};
var PatientEncounter = /** @class */ (function (_super) {
    __extends(PatientEncounter, _super);
    function PatientEncounter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleToggleClick = _this.handleToggleClick.bind(_this);
        _this.handleCoderNotesClick = _this.handleCoderNotesClick.bind(_this);
        _this.handleCoderNotesKeyDown = _this.handleCoderNotesKeyDown.bind(_this);
        _this.state = {
            expandEncounter: true
        };
        return _this;
    }
    PatientEncounter.prototype.handleToggleClick = function (ev) {
        ev.preventDefault();
        var expandEncounter = this.state.expandEncounter;
        var openClaims = this.props.openClaims;
        if (expandEncounter) {
            openClaims = [];
        }
        else {
            openClaims = __spreadArray(__spreadArray([], __read(openClaims), false), [
                { fieldIdentifier: 'showToggle', fieldName: 'showToggle' }
            ], false);
        }
        this.setState({
            expandEncounter: !expandEncounter
        });
        this.props.handleExpansion(!expandEncounter);
    };
    PatientEncounter.prototype.expandEncounter = function (expandEncounter) {
        this.setState({
            expandEncounter: expandEncounter
        });
        this.props.handleExpansion(expandEncounter);
    };
    /**
     * Handles the click event on the "Coder Notes" section.
     * Prevents default behavior and triggers the coder notes info display.
     *
     * @param {React.MouseEvent<HTMLDivElement>} ev - The mouse event object.
     * @returns {void}
     */
    PatientEncounter.prototype.handleCoderNotesClick = function (ev) {
        var _a;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        ev.preventDefault();
        this.props.showCoderNotesInfo(__assign(__assign({}, lookupParams), { patientMRN: (_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_identifier) === null || _a === void 0 ? void 0 : _a.number, serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line }));
    };
    /**
     * Handles the keydown event on the "Coder Notes" section.
     * Triggers the coder notes info display when the Enter key is pressed.
     *
     * @param {React.KeyboardEvent<HTMLDivElement>} ev - The keyboard event object.
     * @returns {void}
     */
    PatientEncounter.prototype.handleCoderNotesKeyDown = function (ev) {
        var _a;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        if (ev.key === 'Enter') {
            ev.preventDefault();
            this.props.showCoderNotesInfo(__assign(__assign({}, lookupParams), { patientMRN: (_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_identifier) === null || _a === void 0 ? void 0 : _a.number, serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line }));
        }
    };
    PatientEncounter.prototype.render = function () {
        var _a, _b;
        var classnames = ['patient-encounter'];
        var expandEncounter = this.state.expandEncounter;
        var _c = this.props, activations = _c.activations, activeItem = _c.activeItem, propertyConfig = _c.propertyConfig, fieldEditorInfo = _c.fieldEditorInfo, capability = _c.capability, coderNotesCapability = _c.coderNotesCapability, workItem = _c.workItem;
        var prop = (0, case_prop_accessor2_1.propAccessor2)(__assign(__assign({}, activeItem), workItem), (_a = activations === null || activations === void 0 ? void 0 : activations.property) !== null && _a !== void 0 ? _a : {});
        var cellMaker = CellMaker(prop, activeItem, fieldEditorInfo, capability, this.props.showProviderInfo);
        var cellPatientMaker = CellPatientMaker(prop, activeItem);
        // all info less last item
        var patientConfig = propertyConfig.patient.slice(0, propertyConfig.patient.length - 1);
        // last item
        var patientLastItem = propertyConfig.patient.slice(-1);
        // add hr less the last one item
        patientConfig = patientConfig.map(function (patient, index) {
            return __assign(__assign({}, patient), { addHr: index + 1 !== patientConfig.length });
        });
        var topRightCell = patientLastItem.map(cellMaker);
        var topCells = patientConfig.map(cellPatientMaker);
        var midCells = propertyConfig.summary.map(cellMaker);
        var bottomCells = propertyConfig.expanded.map(cellMaker);
        var chevronClassNames = [
            'chevron-link',
            'qa-expand-encounter',
            { 'chevron-link-opened': expandEncounter },
            { 'chevron-link-closed': !expandEncounter }
        ];
        var expandEncounterClassNames = [
            'expanded-encounter',
            { 'expanded-encounter-opened': expandEncounter },
            { 'expanded-encounter-closed': !expandEncounter }
        ];
        var showComments = ui_common_1.conditionalUtils.capabilityValue((_b = coderNotesCapability === null || coderNotesCapability === void 0 ? void 0 : coderNotesCapability.on) !== null && _b !== void 0 ? _b : false);
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(classnames) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-info-container", "data-testid": "patient-info-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-top-info-container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "top-patient-info" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-info-primary sensitive-data columns" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "col-12", "data-testid": "patient-info-name" }, { children: prop('patient_name') })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "patient-info-secondary columns" }, { children: topCells }))] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "bottom-patient-info" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "columns" }, { children: topRightCell })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [showComments] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ tabIndex: 0, onClick: this.handleCoderNotesClick, onKeyDown: this.handleCoderNotesKeyDown, className: "coder-comments-section" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconClass: "coder-comments", svgIconName: "BiomeComments", svgIconSize: "24" }) })) }))] })), propertyConfig.summary.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "divider first-divider" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "columns info-block" }, { children: midCells })) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])(expandEncounterClassNames) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "columns info-block" }, { children: bottomCells })) })) }))] })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: propertyConfig.expanded.length > 0 }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "toggle-section", "data-dd-action-name": "~Toggle Section" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "show-toggle", onClick: this.handleToggleClick }, { children: (0, jsx_runtime_1.jsx)(chevron_1["default"], { "data-dd-action-name": "~Toggle Section", onClick: this.handleToggleClick, className: (0, classnames_1["default"])(chevronClassNames) }) })) })) }))] })));
    };
    PatientEncounter.displayName = 'PatientEncounter';
    PatientEncounter.defaultProps = {
        openClaims: [],
        showLoading: false,
        activations: {},
        handleExpansion: function (expanded) { },
        showCoderNotesInfo: function (coderNotesParams) { },
        showProviderInfo: function (providerInfo) { },
        propertyConfig: {
            patient: [],
            summary: [],
            expanded: []
        },
        workItem: {
            owner: '',
            assignee: '',
            aging_days: '',
            codable_days: ''
        }
    };
    return PatientEncounter;
}(react_1["default"].Component));
exports.PatientEncounter = PatientEncounter;
//# sourceMappingURL=patient-encounter.js.map